import $ from "jquery";

import _ from "underscore";

import Modal from "shared/modal";

import Loading from "shared/loading";
import Toast from "shared/toast";

export default class BaseVirtualLineModal extends Modal {
  get className() { return "modal-force-light"; }

  body() {
    return this.form.render();
  }

  configureLoadingMask() {
    Loading.show(this.$('.modal-body'));
    this.model.on("invalid", () => { Loading.hide(); });
  }

  render() {
    if (this.child("body")) {
      this.form.remove();
      this.$(".modal-body").html(this.body().$el);
    } else {
      const superRender = super.render;
      this._populateAccountConfig((...args) => {
        superRender.apply(this, args);
      });
    }

    return this;
  }

  onRequestSuccess(successMessage, model) {
    Toast.success(successMessage);
    this.successCallback(model);
    this.close();
  }

  _resetModel(defaultAttributes) {
    this.model.clear();
    this.model.set(_.extend({
      "advertiser_campaign_id": "",
      "promo_type": this.config.manageVirtualLines.numberTypes[0].value,
      "adwords_account_id": "",
      "description": "",
      "number_pool_location": "",
      "number_pool_whitelist": ""
    }, defaultAttributes));
  }

  _setErrorAndRender(errorMessages) {
    this.model.set("errors", errorMessages);
    Loading.hide();
    this.render();
  }

  _populateAccountConfig(callback) {
    const formattedAccountId = this.model.get('adwords_account_id');
    if (formattedAccountId) {
      this.configureLoadingMask();

      const accountId = formattedAccountId.replace(/-/g, '');
      $.ajax({
        url: this.config.accountsListUrl,
        method: 'GET',
        complete: callback,
        success: ({ adwords_accounts: adwordsAccounts }, statusText) => {
          this._onAccountGetSuccess(adwordsAccounts, accountId, formattedAccountId);
        },
        error: (xhr, statusText, error) => {
          this._storeAccountConfig(accountId, formattedAccountId);
        }
      });
    } else if (this.config.defaultAccount) {
      this._storeAccountConfig(this.config.defaultAccount.id, this.config.defaultAccount.text);
      callback();
    } else {
      callback();
    }
  }

  _onAccountGetSuccess(accounts, accountId, formattedAccountId) {
    const accountMatch = _.find(accounts, ({ id }) => id === accountId);
    if (accountMatch) {
      this._storeAccountConfig(accountId, accountMatch.text);
    } else {
      this._storeAccountConfig(accountId, formattedAccountId);
    }
  }

  _storeAccountConfig(accountId, accountLabel) {
    this.model.set({
      "adwords_account_id": accountId,
      "adwords_account_id_label": accountLabel
    });
    Loading.hide();
  }
}
